import type { AIProvidersData } from "@/app/lib/types/aiProviders";

export const defaultAIProvidersConfig: AIProvidersData = {
  id: 6,
  AiProvidersTitle: "Ask AI about Naavik.ai.",
  defaultPrompt:
    "I'm researching interactive plot mapping software, tools for a township/plotting project and want to understand how Naavik.AI helps Real estate Sales Managers and builders, land developers improve their sales. Please summarize the highlights of the naavik.ai website (https://www.naavik.ai) and reviews.",
  ai_providers: [
    {
      id: 1,
      name: "ChatGPT",
      icon: "chatgpt",
      url: "https://chatgpt.com/?q=",
      displayOrder: "1",
      visible: true,
    },
    {
      id: 3,
      name: "Perplexity",
      icon: "perplexity",
      url: "https://www.perplexity.ai/search/new?q=",
      displayOrder: "2",
      visible: true,
    },
    {
      id: 5,
      name: "Claude",
      icon: "claude",
      url: "https://claude.ai/new?q=",
      displayOrder: "3",
      visible: true,
    },
    {
      id: 7,
      name: "Gemini",
      icon: "gemini",
      url: "https://www.google.com/search?udm=50&aep=11&q=",
      displayOrder: "4",
      visible: true,
    },
  ],
};
